import "../assets/Common.scss";
import "../assets/fonts/font.css";
import React, { useEffect, useState, useRef } from "react";

import { getInsetTop, calc } from "../js/chips-common.js";
import IcBack from "../vending-machine/assets/ic-back.png";

export default function WebLogin() {
  // const dev = props.dev;
  // const domain = dev
  //   ? `https://api.${dev}.chips.today`
  //   : "https://api.chips.today";
  const endPoint = window.location.origin;

  // KAKAO
  const kakaoClientId = "e70756f39b9983141207090ae7dac505";
  const kakaoRedirectUri = `${endPoint}/user/kakao/callback`; //Redirect URI
  const integrityValue =
    "sha384-kDljxUXHaJ9xAb2AzRd59KxjrFjzHa5TAoFQ6GbYTCAG0bjM55XohjjDT7tDDC01";
  const kakaoSdkUrl = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.1/kakao.min.js";
  const initialized = useRef(false);

  // NAVER
  const naverClientId = "EbppPeiqogNH0vZk938b";
  const naverRedirectUri = `${endPoint}/user/naver/callback`; //Redirect URI
  const naverSdkUrl =
    "https://static.nid.naver.com/js/naveridlogin_js_sdk_2.0.2.js";

  const [naverAuthorizeUrl, setNaverAuthorizeUrl] = useState("");

  const NaverLoginButton = () => {
    return (
      <div
        onClick={() => {
          window.location.href = naverAuthorizeUrl;
        }}
      >
        <img
          src="https://cdn.chips.today/logic/images/2024/05/17/1715941619816-88b45fc9-abc5-4597-a1cd-4e785e23e5a2.png"
          style={{ width: calc(30) }}
          alt={"naver-login"}
        />
      </div>
    );
  };

  const KakaoLoginButton = () => {
    const handleKakaoLogin = () => {
      // eslint-disable-next-line no-undef
      if (Kakao.isInitialized()) {
        // eslint-disable-next-line no-undef
        Kakao.Auth.authorize({
          // eslint-disable-next-line no-undef
          redirectUri: `${kakaoRedirectUri}`,
          prompt: "login",
        });
      }
    };
    return (
      <div onClick={() => handleKakaoLogin()}>
        <img
          src="https://cdn.chips.today/logic/images/2024/05/17/1715942472649-5d0fff6d-0252-433e-bda7-eb9dccbe90e2.png"
          style={{ width: calc(30) }}
          alt={"kakao-login"}
        />
      </div>
    );
  };

  useEffect(() => {
    try {
      if (!initialized.current) {
        initialized.current = true;

        // Naver Login SDK
        new Promise((onload, reject) => {
          const src = naverSdkUrl;
          const script = document.createElement("script");
          const onError = (evt) =>
            reject(URIError(`스크립트 로딩 실패 ${evt.target.src}`));
          Object.assign(script, {
            type: "text/javascript",
            onload,
            onError,
            src,
          });
          document.head.appendChild(script);
        }).then(() => {
          // eslint-disable-next-line no-undef
          const naverLogin = new naver.LoginWithNaverId({
            clientId: naverClientId,
            callbackUrl: naverRedirectUri,
            isPopup: false,
            loginButton: { color: "green", type: 2, height: 60 },
          });

          naverLogin.init();
          // eslint-disable-next-line no-undef
          setNaverAuthorizeUrl(naverLogin.generateAuthorizeUrl());
        });

        // Kakao Login SDK
        const kakaoScript = document.createElement("script");
        kakaoScript.src = `${kakaoSdkUrl}`;
        kakaoScript.integrity = integrityValue;
        kakaoScript.crossOrigin = "anonymous";
        kakaoScript.onload = () => {
          // eslint-disable-next-line no-undef
          Kakao.init(kakaoClientId);
        };
        kakaoScript.async = false;
        document.body.appendChild(kakaoScript);
      }
    } catch (e) {}
  }, []);

  return (
    <div
      style={{
        background: "#FFF",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />
      <div id="naverIdLogin" style={{ display: "none" }}></div>
      <div
        className="scrollbar-hidden"
        style={{
          background: "transparent",
          position: "absolute",
          overflowY: "scroll",
          overflowX: "hidden",
          bottom: 0,
          top: 0,
        }}
      >
        <div
          style={{
            position: "fixed",
            top: getInsetTop(),
            width: calc(360),
            zIndex: 1,
          }}
        >
          <div
            className="active-small"
            style={{
              position: "absolute",
              left: 0,
            }}
            onClick={() => {
              window.history.back();
            }}
          >
            <img
              style={{
                width: calc(24),
                height: calc(24),
                margin: `${calc(16)} ${calc(20)}`,
              }}
              src={IcBack}
              alt={"back"}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          content: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100vw",
          height: "100vh",
        }}
      >
        <div>
          <img
            style={{
              width: calc(304),
              height: calc(186),
            }}
            src="https://cdn.chips.today/logic/images/2024/05/17/1715941274789-28b17ae0-9709-4eb9-8618-30c3c7a821a1.png"
            alt={"logo"}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: calc(18),
            gap: calc(30),
          }}
        >
          {NaverLoginButton()}
          {KakaoLoginButton()}
        </div>
      </div>
    </div>
  );
}
